import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../../utils/apolloClient';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';
const { DMS_ACCOUNT_TYPES_MAPPING } = require('../../../components/stepper/stepperBody/stepperBodyComponents/DMSSelectionComponents/utils/constant');

const initialState = {
  updatedDMSAcounts: [],
  isEISDMSInfoPending: false,
  isEISDMSInfoSuccess: false,
  getEISDMSInfo: [],
  isEISDMSInfoLoading: false,
  errorInGetEISDMSInfo: null,
  dmsConfigInfo: [],
  mergedDMSAccounts: [],
  isDMSAccountsUpdatePending: false,
  isDMSAccountsUpdateSuccess: false,
  isDMSAccountsUpdateLoading: false,
  errorInDMSAccountsUpdate: null,
  dmsAccountsUpdatedData: []
};

export const getDMSAccountDetailsFromEISForEditDMSAccounts = createAsyncThunk(
  'getDMSAccountDetailsFromEISForEditDMSAccounts',
  async ({ cmfNumber, storeId, token, location, entityId, dmsInfoDetails }) => {
    const response = await client.authorizeRequest({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/v1/connectCDK/${storeId}`
    });
    return {
      ...response,
      location,
      cmfNumber,
      storeId,
      entityId,
      dmsInfoDetails
    };
  }
);

export const updateDMSAccountsDetailsForApp = createAsyncThunk(
  'updateDMSAccountsDetailsForApp',
  async ({ token, solutionId, updatedDMSAcounts, isNewAPI, bulkSubscribed }) => {
  const response = await client.authorizeRequest({
    method: 'POST',
    data: updatedDMSAcounts,
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/edit-dms-accounts/solutions/${solutionId}?isNewApi=${isNewAPI}&bulkSubscribed=${bulkSubscribed}`
  });
  return response;
});


export const updateDMSAccountsSlice = createSlice({
  name: 'updateDMSAccountsSlice',
  initialState,
  reducers: {
    updateDMSAccounts: (state, action) => {
      const { location, dmsAccount, departments, cmfNumber, dmsAccountType, entityId, type, id } = action.payload;

      let dmsExist = state.updatedDMSAcounts.filter(ele =>
        ele.location === location &&
        ele.cmfNumber === cmfNumber &&
        ele.dmsAccountType === dmsAccountType &&
        ele.entityId === entityId &&
        ele.type === type &&
        ele.id === id
      );
      if (dmsExist.length) {
        const elementsIndex = state.updatedDMSAcounts.findIndex(ele =>
          ele.location === location &&
          ele.cmfNumber === cmfNumber &&
          ele.dmsAccountType === dmsAccountType &&
          ele.entityId === entityId &&
          ele.type === type &&
          ele.id === id
        );

        let newArray = [...state.updatedDMSAcounts];

        newArray[elementsIndex] = {
          ...newArray[elementsIndex],
          dmsAccount,
          departments
        };
        state.updatedDMSAcounts = newArray;
      } else {
        state.updatedDMSAcounts.push(action.payload);
      }
    },
    removeDMSAccounts: (state, action) => {
      let selectedDMSAccount = state.updatedDMSAcounts;
      const { location, entityId, type, id } = action.payload;
      selectedDMSAccount =
        selectedDMSAccount &&
        selectedDMSAccount.filter(
          item =>
            item.location !== location ||
              item.entityId !== entityId ||
              item.type !== type ||
              item.id !== id
        );
      state.updatedDMSAcounts = selectedDMSAccount;
    },
    mergedDMSAccountsList: (state, action) => {
      const { dmsAccountsDataByDMSTypes, dmsAccountListForApp } = action.payload;
      state.mergedDMSAccounts = dmsAccountsDataByDMSTypes;
      state.updatedDMSAcounts = dmsAccountListForApp && dmsAccountListForApp.filter(item => item.dmsAccount);
    },
    clearUpdateDMSAccounts: state => {
      state.updatedDMSAcounts = [];
      state.isEISDMSInfoPending = false;
      state.isEISDMSInfoSuccess = false;
      state.getEISDMSInfo = [];
      state.isEISDMSInfoLoading = false;
      state.errorInGetEISDMSInfo = null;
      state.dmsConfigInfo = [];
      state.mergedDMSAccounts = [];
      state.isDMSAccountsUpdatePending = false;
      state.isDMSAccountsUpdateSuccess = false;
      state.isDMSAccountsUpdateLoading = false;
      state.errorInDMSAccountsUpdate = null;
      state.dmsAccountsUpdatedData = []
    }
  },
  extraReducers: {
    [getDMSAccountDetailsFromEISForEditDMSAccounts.fulfilled]: (state, action) => {
      const {
        data,
        location,
        cmfNumber,
        entityId,
        dmsInfoDetails
      } = action.payload;

      const { dmsConfigInfo, dmsApiDetails } = dmsInfoDetails;
      const dealerStoresData = data || {};
      const dept = [];

      Object.keys(dealerStoresData).length > 0 && dealerStoresData && dealerStoresData.departments && dealerStoresData.departments.length && dealerStoresData.departments.map(
        department => {
          const eisDMSAccountType = department.type && department.type.toUpperCase();
          const dmsAccountTypeFullName = DMS_ACCOUNT_TYPES_MAPPING[eisDMSAccountType];

          const apiIdVal = Object.entries(dmsApiDetails)
            .map(([key, value]) => {
              if(value && value.length && value[0].includes(dmsAccountTypeFullName)) {
                return key;
              }
            })
            .filter(apiId => apiId);

          dept.push({
            id: `${dealerStoresData.id}-${department.id}`,
            location,
            cmfNumber,
            dmsAccount: department.name,
            dmsAccountType: department.type,
            departments: [
              { name: department.name, id: department.id }
            ],
            entityId,
            api: apiIdVal,
            type: dmsAccountTypeFullName
          });
        }
      );

      if (!dealerStoresData.departments.length) {
        dept.push({
          id: `${dealerStoresData.id}-dept-demo`,
          location,
          cmfNumber,
          dmsAccount: '',
          dmsAccountType: '',
          departments: [],
          entityId,
          api: ''
        })
      }

      const dmsAccountsArray = Object.entries(
        dept.reduce((a, {entityId, departments}) => {
          a[entityId] = (a[entityId] || []).concat(departments);
          return a;
        }, {})
      ).map(([entityId, departments]) => ({
        entityId,
        departments,
        dmsAccount: departments.map(d => d.name)
      }));

      const deptWithApiIds = dept.filter(item => item.api);

      const dmsData = [];
      deptWithApiIds.map(item => {
        const dmsAccount = item.dmsAccount;
        const entry = dmsAccountsArray.find(ele => ele.entityId === item.entityId);
        if (entry) {
          const dms = entry.dmsAccount.filter(item => item !== dmsAccount);
          item.dmsAccount = [dmsAccount, ...dms];

          const otherDepts = entry.departments.filter(d => d.name !== dmsAccount);
          item.departments = item.departments.concat(otherDepts);
        }
        dmsData.push(item);
      });

      if (!deptWithApiIds.length && dept.length) {
        Object.entries(dmsApiDetails).map(([key, value]) => {
          dept[0].api = key;
          deptWithApiIds.push(dept[0]);
        });
        deptWithApiIds.map(item => {
          const entry = dmsAccountsArray.find(ele => ele.entityId === item.entityId);
          if (entry) {
            item.dmsAccount = [...entry.dmsAccount];
            item.departments = [...entry.departments];
          }
          dmsData.push(item);
        });
      }

      const updatedLocations = [...state.getEISDMSInfo, ...dmsData];
      const updatedUniqueLocations = [
        ...new Map(
          updatedLocations.map(item => [item['id'], item])
        ).values()
      ];

      state.getEISDMSInfo = updatedUniqueLocations;
      state.dmsConfigInfo = dmsConfigInfo;
      state.isEISDMSInfoSuccess = true;
      state.isEISDMSInfoPending = false;
      state.isEISDMSInfoLoading = false;
    },
    [getDMSAccountDetailsFromEISForEditDMSAccounts.pending]: (state, action) => {
      state.isEISDMSInfoPending = true;
      state.isEISDMSInfoLoading = true;
    },
    [getDMSAccountDetailsFromEISForEditDMSAccounts.rejected]: (state, action) => {
      state.isEISDMSInfoSuccess = false;
      state.isEISDMSInfoPending = true;
      state.isEISDMSInfoLoading = false;
      state.errorInGetEISDMSInfo = action.error;
    },
    [updateDMSAccountsDetailsForApp.fulfilled]: (state, action) => {
      const { data: dmsAccountsUpdatedData } = action.payload;

      state.dmsAccountsUpdatedData = dmsAccountsUpdatedData;
      state.isDMSAccountsUpdatePending = false;
      state.isDMSAccountsUpdateSuccess = true;
      state.isDMSAccountsUpdateLoading = false;
    },
    [updateDMSAccountsDetailsForApp.pending]: (state) => {
      state.isDMSAccountsUpdatePending = true;
      state.isDMSAccountsUpdateLoading = true;
      state.isDMSAccountsUpdateSuccess = false;
    },
    [updateDMSAccountsDetailsForApp.rejected]: (state, action) => {
      state.errorInDMSAccountsUpdate = action.error;
      state.isDMSAccountsUpdatePending = true;
      state.isDMSAccountsUpdateSuccess = false;
      state.isDMSAccountsUpdateLoading = false;
    }
  }
});

export const {
  updateDMSAccounts,
  removeDMSAccounts,
  mergedDMSAccountsList,
  clearUpdateDMSAccounts,
  clearDMS
} = updateDMSAccountsSlice.actions;

export default updateDMSAccountsSlice.reducer;
